// Libs
import React from 'react';
import { Container } from 'react-bootstrap';

//-------------------------------------------------------------------------------------------------------------------

class PageHeader extends React.Component {

    constructor(props) {
        super(props);

        this.onPageClick = this.onPageClick.bind(this);

        this.state = {
        };
    }

    toggleSideBar(forceOpen) {
        const sideBar = document.querySelector('.side-bar');
        if (sideBar) {
            const sideBarToggle = document.querySelector('.side-bar-toggle');
            const page = document.querySelector('.page');
            const isOpen = sideBar.classList.contains('open');
            
            if (isOpen || forceOpen === false) {
                sideBar.classList.remove('open');
                sideBarToggle.classList.remove('open');
                if (page) {
                    page.removeEventListener('click', this.onPageClick);
                }
            }
            else if (!isOpen || forceOpen === true) {
                sideBar.classList.add('open');
                sideBarToggle.classList.add('open');
                if (page) {
                    page.addEventListener('click', this.onPageClick);
                }
            }
        }
    }

    onPageClick(e) {
        const sideBar = document.querySelector('.side-bar');
        if (sideBar && sideBar.contains && !sideBar.contains(e.target)) {
            this.toggleSideBar(false);
            e.stopPropagation();
            e.preventDefault();
        }
    }

    render() {
        const { children, hasSideBar } = this.props;

        return (<>

            <header className="page-header">
                
                <Container fluid={hasSideBar}>

                    {hasSideBar &&
                        <button className="side-bar-toggle btn btn-primary" onClick={() => this.toggleSideBar(null)}>
                            <span className="icon fa-solid fa-chevron-right" />
                        </button>
                    }

                    <div className="page-header-content">

                        {children}

                    </div>

                </Container>

            </header>

        </>);
    }
}

export default PageHeader;
